import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { Router, ActivatedRoute } from '@angular/router';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { IstRegistrationsViewModalComponent } from './ist-registrations-view-modal/ist-registrations-view-modal.component';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { CommonService } from 'src/app/services/common.service';
import { ClientGridComponent } from 'src/app/common/client-grid/client-grid.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ist-registrations',
  templateUrl: './ist-registrations.component.html',
  styleUrls: ['./ist-registrations.component.scss']
})
export class IstRegistrationsComponent implements OnInit {

  @ViewChild(ClientGridComponent) clientgrid;
  @Input() public Content: any;

  gridApi: GridApi;
  columnDefs;
  operations;
  Statuslist: any[] = [];
  tempoperations;
  rowData;
  advanceSearch;
  selectedRow;
  caseDetails;
  content: any
  isSettings: boolean = true;
  moduleType = "IST";
  Status: string;
  ISTAllRegistartions: UntypedFormGroup;
  Tempoperations: { name: string; id: string; }[];
  Tempoperations1: { name: string; id: string; }[];
  IsResendRequired: boolean = true;
  StatusList: any[] = [];

  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: IstSummaryService,
    private modalService: NgbModal,
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute
  ) {
    var pa = this.activatedRoute.snapshot.data['type'];

    if (pa && pa === 'eap') {
      this.moduleType = "EAP";
    } else if (pa && pa === 'ist') {
      this.moduleType = "IST";
    } else {
      this.moduleType = "GRANTS";
    }
    this.activatedRoute.queryParams.subscribe(params => {
      if (params && params.screenName === 'eapRegistrations') {
        this.moduleType = "EAP";
      } else if (params && params.screenName === 'istRegistrations') {
        this.moduleType = "IST";
      } else {
        this.moduleType = "GRANTS";
      }
    })
  }

  ngOnInit() {

    this.Statuslist.push({ label: "All", value: "" })
    this.Statuslist.push({ label: "Blocked", value: "0" })
    this.Statuslist.push({ label: "Unblocked", value: "1" })

    this.ISTAllRegistartions = new UntypedFormGroup({
      OrganizationName: new UntypedFormControl(""),
      FullName: new UntypedFormControl(""),
      MedicalLicenceNumber: new UntypedFormControl(""),
      City: new UntypedFormControl(""),
      State: new UntypedFormControl(""),
      Country: new UntypedFormControl(""),
      Status: new UntypedFormControl(""),
      ModuleType: new UntypedFormControl(this.moduleType),
    });

    this.StatusList = [{ label: "All", value: "", checked: true }].concat(this.StatusList);

    // this.ISTAllRegistartions.get()
    //  [{label:"All",value:"", checked: true}]
    this.columnDefs = [

      {
        "headerName": "Registration ID",
        "field": "RegistrationID",
      },
      {
        "headerName": "Full Name",
        "field": "FullName"
      },
      // {
      //   "headerName": "Medical Licence Number",
      //   "field": "MedicalLicenceNumber"
      // },
      {
        "headerName": "Organization Name",
        "field": "OrganizationName",
      },
      // {
      //   headerName: "Organization Type",
      //   field: "OrganizationType",
      //   cellRenderer: "editOthersRenderer",
      //   colId: "params",
      //   sortable: false,
      //   cellStyle: { "overflow": 'visible' }
      // },
      
      // {
      //   headerName: "Tax Status",
      //   field: "TaxStatus",
      //   cellRenderer: "editOthersRenderer",
      //   colId: "params",
      //   sortable: false,
      //   cellStyle: { "overflow": 'visible' }
      // },
      {
        "headerName": "Status",
        "field": "Status",
      }
    ];

    this.setSummaryData();

    this.advanceSearch =
    {
      "fields": [
        {
          "label": "Organization Name",
          "field": "OrganizationName",
          "type": "text"
        },
        {
          "label": "Full Name",
          "field": "FullName",
          "type": "text"
        },
        {
          "label": "Medical License Number",
          "field": "MedicalLicenceNumber",
          "type": "text"
        },
        {
          "label": "Organization Type",
          "field": "OrganizationType",
          "type": "text"
        },
        {
          "label": "Tax Status",
          "field": "TaxStatus",
          "type": "text"
        }
        // {
        //   "label": "City",
        //   "field": "City",
        //   "type": "text"
        // },
        // {
        //   "label": "State",
        //   "field": "State",
        //   "type": "text"
        // },
        // {
        //   "label": "Country",
        //   "field": "Country",
        //   "type": "text"
        // }
      ]
    };
  }


  setRowOperations(rowData: any[]) {
    
    this.Tempoperations = [];
    this.Tempoperations1 = [];
    this.isSettings = true;
    rowData.forEach(element => {
      
      this.Tempoperations = [];
      this.Tempoperations.push({
        "name": "Edit",
        "id": "edit"
      });
      if (element.IsTempPwd == true && element.BlockStatus==1) {
        this.Tempoperations.push(
          {
            "name": "Resend Email",
            "id": "Resend"
          });
      }
     
        element["Operations"] = this.Tempoperations.map(operation => {
          return operation && operation.id === 'add' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
        });
      
    });
    this.operations = this.Tempoperations.map(operation => {
      return operation && operation.id === 'add' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
    // this.clearCaseDetail();
    //this.setSummaryData();
    // this.SearchClear();
    return rowData;

  }

  clearCaseDetail() {
    this.caseDetails = [
      {
        "caseSet": {
          "caseHeading": "",
          "caseData": [
            // {
            //   "label": "Prefix",
            //   "value": "Prefix"
            // },
            {
              "label": "Full Name",
              "value": "FullName"
            },
            {
              "label": "Email Address",
              "value": "EmailAdress"
            },
            {
              "label": "Medical License Number",
              "value": "MedicalLicenceNumber"
            },
            {
              "label": "Address",
              "value": "Address"
            }
            // ,
            // {
            //   "label": "City - Postal Code",
            //   "value": "PersonCity_PostalCode"
            // },
            // {
            //   "label": "State, Country",
            //   "value": "PersonStateCountry"
            // }
          ]

        }
      },
      {
        "caseSet": {
          "caseHeading": "Organization Details",
          "caseData": [
            {
              "label": "Email Address",
              "value": "EmailAdress"
            },
            {
              "label": "Name of Organization",
              "value": "OrganizationName"
            },
            {
              "label": "Organization Website",
              "value": "OrganizationWebSite"
            },
            {
              "label": "Address",
              "value": "OrganizationAddress"
            },
            // {
            //   "label": "City - Postal Code",
            //   "value": "OrgCity_PostalCode"
            // },
            // {
            //   "label": "State, Country",
            //   "value": "OrgStateCountry"
            // },
            {
              "label": "Institution Tax Number",
              "value": "OrganizationTaxNumber"
            }
          ]

        }
      }
    ];
  }

  setSummaryData() {
    //this.SearchClear();
    var data = this.moduleType;
    this.ISTAllRegistartions.reset();
    this.ISTAllRegistartions.get("Status").setValue("");
    this.summaryService.getRegistSummary("api/ISTRegistration/getSummaryData?module=" + this.moduleType).subscribe(summary => {
      this.rowData = summary;
      this.setRowOperations(this.rowData);

    });
  }
  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
    if (!this.modalService.hasOpenModals()) {
      let modelRef = this.modalService.open(IstRegistrationsViewModalComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-vlg right modal-right',
        animation: true
      });
      modelRef.componentInstance.Content = {
        heading: 'View',
        content: { id: event.data['ID'], Module: this.moduleType }
      }
      modelRef.result.then(result => {
        if (result) {
          this['self'].setSummaryData();

        }
      });
    }
  }

  edit() {
  
    let modalRef = this['self'].modalService.open(IstRegistrationsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'Edit',
      content: { id: this['self'].selectedRow['ID'],orgID: this['self'].selectedRow['OrganizationID'] }
    };
    modalRef.result.then((result) => {
      this['self'].setSummaryData();
    });
  }

  add() {
    
      let modalRef = this.modalService.open(IstRegistrationsViewModalComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-vlg right modal-right',
        animation: true
      });
    modalRef.componentInstance.Content={
      heading: 'Enroll your',
        content: null
      }
    modalRef.result.then(result=>{
      this['self'].setSummary();
      });
    
  }

  SearchClear() {
    this.ISTAllRegistartions.reset();
    this.ISTAllRegistartions.get("Status").setValue("");
  }

  AdvanceSearch() {
    var formDate = this.ISTAllRegistartions.value;
    formDate.ModuleType = this.moduleType;
    //this.gridApi.cle
    this.clientgrid.clearCase(this.caseDetails);
    this.summaryService.fetchSearchData("api/ISTRegistration/getSummarySearchData", formDate).subscribe(summary => {
      this.rowData = summary;
      // this.caseDetails = summary;
    });
  }

  Resend() {
    let id = this['self'].selectedRow["ID"];
    // let OrgId = this['self'].orgId;
    this['self'].summaryService.resendUserEmail(id, "1").subscribe(summary => {
      if (summary != null && summary.Status == 0) {
        this['self'].commonService.SuccessBanner(summary.Message);
      } else if (summary.ErrorCode == "MAILEXCEPTION") {
        this['self'].commonService.ValidationBanner("Unable to send email to users. Please try again");
      }
    });
  }
}




